var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eden-content--empty"},[_c('el-empty',{attrs:{"description":_vm.text,"image-size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }